import { ASSIST_DOMAINS } from '@/navbar/constants/assist-domains'
import { FEATURE_FLAG_DOMAINS } from '@/navbar/constants/feature-flag-domains'
import { type Region } from '@/navbar/navbar.types'

/** Hostname → region lookup derived from the {@link ASSIST_DOMAINS} allow-list. */
const ASSIST_HOST_TO_REGION = new Map(
  (Object.entries(ASSIST_DOMAINS) as [Region, string][]).map(
    ([region, url]) => [new URL(url).hostname, region],
  ),
)

/**
 * Derives a Feature Flag Service domain from an Assist domain by strict lookup
 * against the known {@link ASSIST_DOMAINS} allow-list.
 * Current Assist domains are listed in src/navbar/docs/Domains.mdx.
 *
 * The input is normalised via the WHATWG URL parser (lowercased, port and
 * trailing dot stripped) before lookup, so minor formatting variants of a
 * known host still resolve correctly.
 * Returns `undefined` when the input does not match a known Assist domain.
 */
export function mapAssistDomainToFeatureFlagDomain(assistDomain?: string): string | undefined {
  if (!assistDomain) return undefined

  const withProtocol = /^https?:\/\//i.test(assistDomain) ? assistDomain : `https://${assistDomain}`
  let hostname: string
  try {
    hostname = new URL(withProtocol).hostname.replace(/\.$/, '')
  } catch {
    return undefined
  }

  const region = ASSIST_HOST_TO_REGION.get(hostname)
  return region !== undefined ? FEATURE_FLAG_DOMAINS[region] : undefined
}
